<template>
    <div class="d-flex flex-column" id="p_rappel">
        <v-row ref="headerFilters">
            <data-table-filters v-if="!isMobile"
                :name="tb('Rappel')"
                :has-active-filters="hasActiveFilters"
                :filters="filters"
                :schema="tSchema(schema)"
                @remove-filter="removeFilter"
                @refresh="refresh"
                @clear-filters="onClearFilters()">
            </data-table-filters>
            <div class="col wrap-title-filters" v-else >
                <filters-dialog
                    :name="tb('Rappel')"
                    :has-active-filters="hasActiveFilters"
                    :filters="filters" :schema="tSchema(schema)"
                    @remove-filter="removeFilter"
                    @refresh="refresh"
                    @clear-filters="onClearFilters()">
                </filters-dialog>
            </div>
        </v-row>

        <v-row>
            <v-col>
                <portal to="v-form-base">
                    <v-form-base :model="filters" :schema="tSchema(schema)" @input="refresh"></v-form-base>
                </portal>

                <app-card class="fill-height" contentIsScrollable="true" :contentStyle="`height: ${contentCardHeight}px;`" v-if="!isMobile">
                    <template v-slot:content-no-margin>
                        <v-card-title class="d-flex align-center title-text dark-blue-color py-0 ml-1 mr-1" style="height: 65px">
                            <span class="mr-auto">{{ tb('Selecione o período a consultar e o tipo de consulta') }}</span>
                            <div class="d-flex flex-column font-size-lg">
                                <span v-if="currentRappel !== null">{{ tb('Rappel Atual por descontar') }}</span>

                                <div v-if="currentRappel !== null" class="btn-bg-color-dark-blue py-1" style="border-radius: 8px">
                                    <div class="d-flex align-center justify-center fill-height">
                                        <span class="font-weight-regular white--text">{{ formatPrice(currentRappel) }}</span>
                                    </div>
                                </div>
                            </div>
                        </v-card-title>

                        <div class="mt-4 datatable-footer-border ml-5 mr-5"></div>

                        <v-tabs v-if="contracts.length > 1" v-model="selectedContractIndex" class="ml-5 mt-4" show-arrows next-icon="mdi-chevron-right" prev-icon="mdi-chevron-left" height="35px">
                            <v-tabs-slider color="#154579"></v-tabs-slider>

                            <template v-for="(contract, index) in contracts">
                                <v-tab :key="index" class="myprovet-tab-item">{{ $t('rappel.contract', { name: contract.label }) }}</v-tab>
                            </template>
                        </v-tabs>

                        <div class="ml-9" v-for="year in visibleYears" :key="year">
                            <v-row class="mt-2">
                                <v-col cols="2">
                                    <div class="d-flex align-center title-text dark-blue-color fill-height py-0">
                                        <span>{{ year }}</span>
                                    </div>
                                </v-col>

                                <v-col cols="10" class="d-flex">
                                    <div class="d-flex align-center fill-height">
                                        <v-radio-group v-if="partitions === 1" v-model="selectedPartition[partitions]" row hide-details dense class="mt-0">
                                            <RadioInput class="month-container" v-if="showMonth(year, 1)" :text="tb('Jan')" :value="year + '-01'" :active="selectedPartition[partitions] === year + '-01'"></RadioInput>
                                            <RadioInput class="month-container" v-if="showMonth(year, 2)" :text="tb('Fev')" :value="year + '-02'" :active="selectedPartition[partitions] === year + '-02'"></RadioInput>
                                            <RadioInput class="month-container" v-if="showMonth(year, 3)" :text="tb('Mar')" :value="year + '-03'" :active="selectedPartition[partitions] === year + '-03'"></RadioInput>
                                            <RadioInput class="month-container" v-if="showMonth(year, 4)" :text="tb('Abr')" :value="year + '-04'" :active="selectedPartition[partitions] === year + '-04'"></RadioInput>
                                            <RadioInput class="month-container" v-if="showMonth(year, 5)" :text="tb('Mai')" :value="year + '-05'" :active="selectedPartition[partitions] === year + '-05'"></RadioInput>
                                            <RadioInput class="month-container" v-if="showMonth(year, 6)" :text="tb('Jun')" :value="year + '-06'" :active="selectedPartition[partitions] === year + '-06'"></RadioInput>
                                            <RadioInput class="month-container" v-if="showMonth(year, 7)" :text="tb('Jul')" :value="year + '-07'" :active="selectedPartition[partitions] === year + '-07'"></RadioInput>
                                            <RadioInput class="month-container" v-if="showMonth(year, 8)" :text="tb('Ago')" :value="year + '-08'" :active="selectedPartition[partitions] === year + '-08'"></RadioInput>
                                            <RadioInput class="month-container" v-if="showMonth(year, 9)" :text="tb('Set')" :value="year + '-09'" :active="selectedPartition[partitions] === year + '-09'"></RadioInput>
                                            <RadioInput class="month-container" v-if="showMonth(year, 10)" :text="tb('Out')" :value="year + '-10'" :active="selectedPartition[partitions] === year + '-10'"></RadioInput>
                                            <RadioInput class="month-container" v-if="showMonth(year, 11)" :text="tb('Nov')" :value="year + '-11'" :active="selectedPartition[partitions] === year + '-11'"></RadioInput>
                                            <RadioInput class="month-container" v-if="showMonth(year, 12)" :text="tb('Dez')" :value="year + '-12'" :active="selectedPartition[partitions] === year + '-12'"></RadioInput>
                                        </v-radio-group>

                                        <v-radio-group v-if="partitions === 3" v-model="selectedPartition[partitions]" row hide-details dense class="mt-0">
                                            <RadioInput class="trimester-container" v-if="showMonth(year, 1)" :text="tb('Jan - Fev - Mar')" :value="year + '-01'" :active="selectedPartition[partitions] === year + '-01'"></RadioInput>
                                            <RadioInput class="trimester-container" v-if="showMonth(year, 4)" :text="tb('Abr - Mai - Jun')" :value="year + '-04'" :active="selectedPartition[partitions] === year + '-04'"></RadioInput>
                                            <RadioInput class="trimester-container" v-if="showMonth(year, 7)" :text="tb('Jul - Ago - Set')" :value="year + '-07'" :active="selectedPartition[partitions] === year + '-07'"></RadioInput>
                                            <RadioInput class="trimester-container" v-if="showMonth(year, 10)" :text="tb('Out - Nov - Dez')" :value="year + '-10'" :active="selectedPartition[partitions] === year + '-10'"></RadioInput>
                                        </v-radio-group>

                                        <v-radio-group v-if="partitions === 6" v-model="selectedPartition[partitions]" row hide-details dense class="mt-0">
                                            <RadioInput class="semester-container" v-if="showMonth(year, 1)" :text="tb('Jan - Fev - Mar - Abr - Mai - Jun')" :value="year + '-01'" :active="selectedPartition[partitions] === year + '-01'"></RadioInput>
                                            <RadioInput class="semester-container" v-if="showMonth(year, 7)" :text="tb('Jul - Ago - Set - Out - Nov - Dez')" :value="year + '-07'" :active="selectedPartition[partitions] === year + '-07'"></RadioInput>
                                        </v-radio-group>

                                        <v-radio-group v-if="partitions === 12" v-model="selectedPartition[partitions]" row hide-details dense class="mt-0">
                                            <RadioInput class="year-container" :text="tb('Jan - Dez')" :value="year + '-01'" :active="selectedPartition[partitions] === year + '-01'"></RadioInput>
                                        </v-radio-group>
                                    </div>
                                </v-col>
                            </v-row>

                            <v-row v-for="rappelType of rappelTypes(year)" :key="rappelType">
                                <v-col cols="2">
                                    <span class="dark-blue-color">Rappel {{ getRappelTypeLabel(rappelType, year) }}</span>
                                </v-col>

                                <v-col cols="10">
                                    <div class="d-flex align-center fill-height" style="flex-direction: row; flex-wrap: wrap">
                                        <template v-if="partitions === 1">
                                            <template v-for="position in 12">
                                                <div v-if="showMonth(year, position)" :key="position" class="d-flex justify-center monthly-input">
                                                    <p v-if="getRappelTotalsAt(rappelType, year, position)" class="dark-blue-color">{{ getRappelTotalsAt(rappelType, year, position).rappel_percentage_to_pay }}%</p>

                                                    <p v-else class="dark-blue-color">-</p>
                                                </div>
                                            </template>
                                        </template>

                                        <template v-if="partitions === 3">
                                            <template v-for="position in trimesterMonths">
                                                <div v-if="showMonth(year, position)" :key="position" class="d-flex justify-center trimester-input">
                                                    <p v-if="getRappelTotalsAt(rappelType, year, position)" class="dark-blue-color">{{ getRappelTotalsAt(rappelType, year, position).rappel_percentage_to_pay }}%</p>

                                                    <p v-else class="dark-blue-color">-</p>
                                                </div>
                                            </template>
                                        </template>

                                        <template v-if="partitions === 6">
                                            <template v-for="position in semesterMonths">
                                                <div v-if="showMonth(year, position)" :key="position" class="d-flex justify-center semester-input">
                                                    <p v-if="getRappelTotalsAt(rappelType, year, position)" class="dark-blue-color">{{ getRappelTotalsAt(rappelType, year, position).rappel_percentage_to_pay }}%</p>

                                                    <p v-else class="dark-blue-color">-</p>
                                                </div>
                                            </template>
                                        </template>

                                        <template v-if="partitions === 12">
                                            <div class="d-flex justify-center yearly-input">
                                                <p v-if="getRappelTotalsAt(rappelType, year, 1)" class="dark-blue-color">{{ getRappelTotalsAt(rappelType, year, 1).rappel_percentage_to_pay }}%</p>

                                                <p v-else class="dark-blue-color">-</p>
                                            </div>
                                        </template>
                                    </div>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="2">
                                    <span class="dark-blue-color">{{ tb('Exportação de Rappel pago') }}</span>
                                </v-col>

                                <v-col cols="10">
                                    <div class="d-flex align-center fill-height" style="flex-direction: row; flex-wrap: wrap">
                                        <template v-if="partitions === 1">
                                            <template v-for="position in 12">
                                                <div v-if="showMonth(year, position)" :key="position" class="mb-2 d-flex justify-center monthly-input">
                                                    <v-tooltip bottom open-on-hover content-class="myprovet-tooltip" v-if="hasRappelTotalsAt(year, position)">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <div class="btn-bg-color-blue pa-1" style="border-radius: 8px" v-on="on" v-bind="attrs">
                                                                <v-icon class="dark-blue-color" @click="downloadInvoice(partitions, year, position)">mdi-tray-arrow-down</v-icon>
                                                            </div>
                                                        </template>

                                                        <span>{{ tb('Descarregar documento') }}</span>
                                                    </v-tooltip>
                                                </div>
                                            </template>
                                        </template>

                                        <template v-if="partitions === 3">
                                            <template v-for="position in trimesterMonths">
                                                <div v-if="showMonth(year, position)" :key="position" class="mb-2 d-flex justify-center trimester-input">
                                                    <v-tooltip bottom open-on-hover content-class="myprovet-tooltip" v-if="hasRappelTotalsAt(year, position)">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <div class="btn-bg-color-blue pa-1" style="border-radius: 8px" v-on="on" v-bind="attrs">
                                                                <v-icon class="dark-blue-color" @click="downloadInvoice(partitions, year, position)">mdi-tray-arrow-down</v-icon>
                                                            </div>
                                                        </template>

                                                        <span>{{ tb('Descarregar documento') }}</span>
                                                    </v-tooltip>
                                                </div>
                                            </template>
                                        </template>

                                        <template v-if="partitions === 6">
                                            <template v-for="position in semesterMonths">
                                                <div v-if="showMonth(year, position)" :key="position" class="mb-2 d-flex justify-center semester-input">
                                                    <v-tooltip bottom open-on-hover content-class="myprovet-tooltip" v-if="hasRappelTotalsAt(year, position)">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <div class="btn-bg-color-blue pa-1" style="border-radius: 8px" v-on="on" v-bind="attrs">
                                                                <v-icon class="dark-blue-color" @click="downloadInvoice(partitions, year, position)">mdi-tray-arrow-down</v-icon>
                                                            </div>
                                                        </template>

                                                        <span>{{ tb('Descarregar documento') }}</span>
                                                    </v-tooltip>
                                                </div>
                                            </template>
                                        </template>

                                        <template v-if="partitions === 12">
                                            <div class="d-flex justify-center yearly-input">
                                                <v-tooltip bottom open-on-hover content-class="myprovet-tooltip" v-if="hasRappelTotalsAt(year, 1)">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <div class="btn-bg-color-blue pa-1" style="border-radius: 8px" v-on="on" v-bind="attrs">
                                                            <v-icon class="dark-blue-color" @click="downloadInvoice(partitions, year, 1)">mdi-tray-arrow-down</v-icon>
                                                        </div>
                                                    </template>

                                                    <span>{{ tb('Descarregar documento') }}</span>
                                                </v-tooltip>
                                            </div>
                                        </template>
                                    </div>
                                </v-col>
                            </v-row>
                        </div>

                        <div class="ml-9">
                            <v-row class="mt-10">
                                <v-col cols="2">
                                    <div class="d-flex align-center fill-height">
                                        <span class="title-text dark-blue-color">{{ tb('Tipo de consulta') }}</span>
                                    </div>
                                </v-col>

                                <v-col cols="10">
                                    <div class="d-flex align-center fill-height">
                                        <v-radio-group v-model="rappelType" row hide-details dense class="mt-0">
                                            <RadioInput :text="tb(calculatedRappel)" :value="calculatedRappel" :active="rappelType === calculatedRappel"></RadioInput>
                                            <RadioInput :text="tb(paidRappel)" :value="paidRappel" :active="rappelType === paidRappel" :disabled="!selectedMonth" @outer-click="onPaidRappelClick"></RadioInput>
                                        </v-radio-group>
                                    </div>
                                </v-col>
                            </v-row>
                        </div>

                        <div class="mt-10"></div>

                        <CalculatedRappel
                            v-show="rappelType === calculatedRappel"
                            :filters="filters"
                            :contract="selectedContract"
                            :selectedRappel="selectedRappel"
                            :levels="levels"
                            :selected-year="selectedYear"
                            :selected-partition="selectedPartition"
                            :partitions="partitions"
                            :contractCondition200NCC="contractCondition200NCC"
                            :contractCondition250NCC="contractCondition250NCC"
                            :contractCondition202CCE="contractCondition202CCE"
                            :contractCondition203CCP="contractCondition203CCP"
                            :contractCondition204CCNCE="contractCondition204CCNCE"
                        ></CalculatedRappel>

                        <PaidRappel v-if="rappelType === paidRappel" :schema="tSchema(schema)" :filters="filters" :contract="selectedContract" :headers="tHeaders(headers)" :query-params="queryParams" :selected-partition="selectedPartition"></PaidRappel>
                    </template>
                </app-card>
                <app-card class="fill-height" contentIsScrollable="true" :contentStyle="`height: ${contentCardHeight}px;`" v-else>
                    <template v-slot:content-no-margin >
                        <v-card-title class="d-flex align-center title-text dark-blue-color py-0 ml-1 mr-1" style="height: 65px">
                            <div class="d-flex flex-column font-size-lg">
                                <span v-if="currentRappel !== null">{{ tb('Rappel Atual por descontar') }}</span>

                                <div v-if="currentRappel !== null" class="btn-bg-color-dark-blue py-1" style="border-radius: 8px">
                                    <div class="d-flex align-center justify-center fill-height">
                                        <span class="font-weight-regular white--text">{{ formatPrice(currentRappel) }}</span>
                                    </div>
                                </div>
                            </div>
                        </v-card-title>

                        <div class="mt-4 datatable-footer-border ml-5 mr-5"></div>
                        <v-col cols="12">
                                    <div class="d-flex align-center title-text dark-blue-color fill-height py-0">
                                        <span>{{ tb('Selecione o período a consultar e o tipo de consulta') }}</span>
                                    </div>
                                </v-col>

                        <v-tabs v-if="contracts.length > 1" v-model="selectedContractIndex" class="ml-5 mt-4" show-arrows next-icon="mdi-chevron-right" prev-icon="mdi-chevron-left" height="35px">
                            <v-tabs-slider color="#154579"></v-tabs-slider>

                            <template v-for="(contract, index) in contracts">
                                <v-tab :key="index" class="myprovet-tab-item">{{ $t('rappel.contract', { name: contract.label }) }}</v-tab>
                            </template>
                        </v-tabs>

                        <div class="ml-0" v-for="year in visibleYears" :key="year">
                            <v-row class="mt-2">
                                <v-col cols="12">
                                    <div class="d-flex align-center title-text dark-blue-color fill-height py-0">
                                        <span>{{ year }}</span>
                                    </div>
                                </v-col>

                                <v-col cols="12" class="d-flex">
                                    <div class="d-flex align-center fill-height">
                                        <v-radio-group v-if="partitions === 1" v-model="selectedPartition[partitions]" row hide-details dense class="mt-0">
                                            <RadioInput class="month-container" v-if="showMonth(year, 1)" :text="tb('Jan')" :value="year + '-01'" :active="selectedPartition[partitions] === year + '-01'"></RadioInput>
                                            <RadioInput class="month-container" v-if="showMonth(year, 2)" :text="tb('Fev')" :value="year + '-02'" :active="selectedPartition[partitions] === year + '-02'"></RadioInput>
                                            <RadioInput class="month-container" v-if="showMonth(year, 3)" :text="tb('Mar')" :value="year + '-03'" :active="selectedPartition[partitions] === year + '-03'"></RadioInput>
                                            <RadioInput class="month-container" v-if="showMonth(year, 4)" :text="tb('Abr')" :value="year + '-04'" :active="selectedPartition[partitions] === year + '-04'"></RadioInput>
                                            <RadioInput class="month-container" v-if="showMonth(year, 5)" :text="tb('Mai')" :value="year + '-05'" :active="selectedPartition[partitions] === year + '-05'"></RadioInput>
                                            <RadioInput class="month-container" v-if="showMonth(year, 6)" :text="tb('Jun')" :value="year + '-06'" :active="selectedPartition[partitions] === year + '-06'"></RadioInput>
                                            <RadioInput class="month-container" v-if="showMonth(year, 7)" :text="tb('Jul')" :value="year + '-07'" :active="selectedPartition[partitions] === year + '-07'"></RadioInput>
                                            <RadioInput class="month-container" v-if="showMonth(year, 8)" :text="tb('Ago')" :value="year + '-08'" :active="selectedPartition[partitions] === year + '-08'"></RadioInput>
                                            <RadioInput class="month-container" v-if="showMonth(year, 9)" :text="tb('Set')" :value="year + '-09'" :active="selectedPartition[partitions] === year + '-09'"></RadioInput>
                                            <RadioInput class="month-container" v-if="showMonth(year, 10)" :text="tb('Out')" :value="year + '-10'" :active="selectedPartition[partitions] === year + '-10'"></RadioInput>
                                            <RadioInput class="month-container" v-if="showMonth(year, 11)" :text="tb('Nov')" :value="year + '-11'" :active="selectedPartition[partitions] === year + '-11'"></RadioInput>
                                            <RadioInput class="month-container" v-if="showMonth(year, 12)" :text="tb('Dez')" :value="year + '-12'" :active="selectedPartition[partitions] === year + '-12'"></RadioInput>
                                        </v-radio-group>

                                        <v-radio-group v-if="partitions === 3" v-model="selectedPartition[partitions]" row hide-details dense class="mt-0">
                                            <RadioInput class="trimester-container" v-if="showMonth(year, 1)" :text="tb('Jan - Fev - Mar')" :value="year + '-01'" :active="selectedPartition[partitions] === year + '-01'"></RadioInput>
                                            <RadioInput class="trimester-container" v-if="showMonth(year, 4)" :text="tb('Abr - Mai - Jun')" :value="year + '-04'" :active="selectedPartition[partitions] === year + '-04'"></RadioInput>
                                            <RadioInput class="trimester-container" v-if="showMonth(year, 7)" :text="tb('Jul - Ago - Set')" :value="year + '-07'" :active="selectedPartition[partitions] === year + '-07'"></RadioInput>
                                            <RadioInput class="trimester-container" v-if="showMonth(year, 10)" :text="tb('Out - Nov - Dez')" :value="year + '-10'" :active="selectedPartition[partitions] === year + '-10'"></RadioInput>
                                        </v-radio-group>

                                        <v-radio-group v-if="partitions === 6" v-model="selectedPartition[partitions]" row hide-details dense class="mt-0">
                                            <RadioInput class="semester-container" v-if="showMonth(year, 1)" :text="tb('Jan - Fev - Mar - Abr - Mai - Jun')" :value="year + '-01'" :active="selectedPartition[partitions] === year + '-01'"></RadioInput>
                                            <RadioInput class="semester-container" v-if="showMonth(year, 7)" :text="tb('Jul - Ago - Set - Out - Nov - Dez')" :value="year + '-07'" :active="selectedPartition[partitions] === year + '-07'"></RadioInput>
                                        </v-radio-group>

                                        <v-radio-group v-if="partitions === 12" v-model="selectedPartition[partitions]" row hide-details dense class="mt-0">
                                            <RadioInput class="year-container" :text="tb('Jan - Dez')" :value="year + '-01'" :active="selectedPartition[partitions] === year + '-01'"></RadioInput>
                                        </v-radio-group>
                                    </div>
                                </v-col>
                            </v-row>

                            <v-row v-for="rappelType of rappelTypes(year)" :key="rappelType">
                                <v-col cols="12">
                                    <span class="dark-blue-color">Rappel {{ getRappelTypeLabel(rappelType, year) }}</span>
                                </v-col>

                                <v-col cols="12">
                                    <div class="d-flex align-center fill-height" style="flex-direction: row; flex-wrap: wrap">
                                        <template v-if="partitions === 1">
                                            <template v-for="position in 12">
                                                <div v-if="showMonth(year, position)" :key="position" class="d-flex justify-center monthly-input">
                                                    <p v-if="getRappelTotalsAt(rappelType, year, position)" class="dark-blue-color">{{ getRappelTotalsAt(rappelType, year, position).rappel_percentage_to_pay }}%</p>

                                                    <p v-else class="dark-blue-color">-</p>
                                                </div>
                                            </template>
                                        </template>

                                        <template v-if="partitions === 3">
                                            <template v-for="position in trimesterMonths">
                                                <div v-if="showMonth(year, position)" :key="position" class="d-flex justify-center trimester-input">
                                                    <p v-if="getRappelTotalsAt(rappelType, year, position)" class="dark-blue-color">{{ getRappelTotalsAt(rappelType, year, position).rappel_percentage_to_pay }}%</p>

                                                    <p v-else class="dark-blue-color">-</p>
                                                </div>
                                            </template>
                                        </template>

                                        <template v-if="partitions === 6">
                                            <template v-for="position in semesterMonths">
                                                <div v-if="showMonth(year, position)" :key="position" class="d-flex justify-center semester-input">
                                                    <p v-if="getRappelTotalsAt(rappelType, year, position)" class="dark-blue-color">{{ getRappelTotalsAt(rappelType, year, position).rappel_percentage_to_pay }}%</p>

                                                    <p v-else class="dark-blue-color">-</p>
                                                </div>
                                            </template>
                                        </template>

                                        <template v-if="partitions === 12">
                                            <div class="d-flex justify-center yearly-input">
                                                <p v-if="getRappelTotalsAt(rappelType, year, 1)" class="dark-blue-color">{{ getRappelTotalsAt(rappelType, year, 1).rappel_percentage_to_pay }}%</p>

                                                <p v-else class="dark-blue-color">-</p>
                                            </div>
                                        </template>
                                    </div>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <span class="dark-blue-color">{{ tb('Exportação de Rappel pago') }}</span>
                                </v-col>

                                <v-col cols="12">
                                    <div class="d-flex align-center fill-height" style="flex-direction: row; flex-wrap: wrap">
                                        <template v-if="partitions === 1">
                                            <template v-for="position in 12">
                                                <div v-if="showMonth(year, position)" :key="position" class="mb-2 d-flex justify-center monthly-input">
                                                    <v-tooltip bottom open-on-hover content-class="myprovet-tooltip" v-if="hasRappelTotalsAt(year, position)">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <div class="btn-bg-color-blue pa-1" style="border-radius: 8px" v-on="on" v-bind="attrs">
                                                                <v-icon class="dark-blue-color" @click="downloadInvoice(partitions, year, position)">mdi-tray-arrow-down</v-icon>
                                                            </div>
                                                        </template>

                                                        <span>{{ tb('Descarregar documento') }}</span>
                                                    </v-tooltip>
                                                </div>
                                            </template>
                                        </template>

                                        <template v-if="partitions === 3">
                                            <template v-for="position in trimesterMonths">
                                                <div v-if="showMonth(year, position)" :key="position" class="mb-2 d-flex justify-center trimester-input">
                                                    <v-tooltip bottom open-on-hover content-class="myprovet-tooltip" v-if="hasRappelTotalsAt(year, position)">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <div class="btn-bg-color-blue pa-1" style="border-radius: 8px" v-on="on" v-bind="attrs">
                                                                <v-icon class="dark-blue-color" @click="downloadInvoice(partitions, year, position)">mdi-tray-arrow-down</v-icon>
                                                            </div>
                                                        </template>

                                                        <span>{{ tb('Descarregar documento') }}</span>
                                                    </v-tooltip>
                                                </div>
                                            </template>
                                        </template>

                                        <template v-if="partitions === 6">
                                            <template v-for="position in semesterMonths">
                                                <div v-if="showMonth(year, position)" :key="position" class="mb-2 d-flex justify-center semester-input">
                                                    <v-tooltip bottom open-on-hover content-class="myprovet-tooltip" v-if="hasRappelTotalsAt(year, position)">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <div class="btn-bg-color-blue pa-1" style="border-radius: 8px" v-on="on" v-bind="attrs">
                                                                <v-icon class="dark-blue-color" @click="downloadInvoice(partitions, year, position)">mdi-tray-arrow-down</v-icon>
                                                            </div>
                                                        </template>

                                                        <span>{{ tb('Descarregar documento') }}</span>
                                                    </v-tooltip>
                                                </div>
                                            </template>
                                        </template>

                                        <template v-if="partitions === 12">
                                            <div class="d-flex justify-center yearly-input">
                                                <v-tooltip bottom open-on-hover content-class="myprovet-tooltip" v-if="hasRappelTotalsAt(year, 1)">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <div class="btn-bg-color-blue pa-1" style="border-radius: 8px" v-on="on" v-bind="attrs">
                                                            <v-icon class="dark-blue-color" @click="downloadInvoice(partitions, year, 1)">mdi-tray-arrow-down</v-icon>
                                                        </div>
                                                    </template>

                                                    <span>{{ tb('Descarregar documento') }}</span>
                                                </v-tooltip>
                                            </div>
                                        </template>
                                    </div>
                                </v-col>
                            </v-row>
                        </div>

                        <div class="ml-0">
                            <v-row class="mt-10">
                                <v-col cols="12">
                                    <div class="d-flex align-center fill-height">
                                        <span class="title-text dark-blue-color">{{ tb('Tipo de consulta') }}</span>
                                    </div>
                                </v-col>

                                <v-col cols="12">
                                    <div class="d-flex align-center fill-height wrap-rappel-type">
                                        <v-radio-group v-model="rappelType" row hide-details dense class="mt-0">
                                            <RadioInput :text="tb(calculatedRappel)" :value="calculatedRappel" :active="rappelType === calculatedRappel"></RadioInput>
                                            <RadioInput :text="tb(paidRappel)" :value="paidRappel" :active="rappelType === paidRappel" :disabled="!selectedMonth" @outer-click="onPaidRappelClick"></RadioInput>
                                        </v-radio-group>
                                    </div>
                                </v-col>
                            </v-row>
                        </div>

                        <div class="mt-10"></div>

                        <CalculatedRappel
                            :isMobile="isMobile"
                            v-show="rappelType === calculatedRappel"
                            :filters="filters"
                            :contract="selectedContract"
                            :selectedRappel="selectedRappel"
                            :levels="levels"
                            :selected-year="selectedYear"
                            :selected-partition="selectedPartition"
                            :partitions="partitions"
                            :contractCondition200NCC="contractCondition200NCC"
                            :contractCondition250NCC="contractCondition250NCC"
                            :contractCondition202CCE="contractCondition202CCE"
                            :contractCondition203CCP="contractCondition203CCP"
                            :contractCondition204CCNCE="contractCondition204CCNCE"
                        ></CalculatedRappel>

                        <PaidRappel
                        v-if="rappelType === paidRappel"
                        :schema="tSchema(schema)" :filters="filters"
                        :contract="selectedContract"
                        :headers="tHeaders(headers)"
                        :query-params="queryParams"
                        :selected-partition="selectedPartition">
                    </PaidRappel>
                    </template>
                </app-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { mapStores } from 'pinia';
import { useBranchStore } from '@/Stores/branch';
import { useCategoriesStore } from '@/Stores/categories';
import { useAppStore } from '@/Stores/app';
import { axios } from '@/Services/Backend';
import MainLayout from './../../Layouts/MainLayout';
import VFormBase from 'vuetify-form-base';
import moment from 'moment';
import ResizeObserver from 'resize-observer-polyfill';

export default {
    layout: MainLayout,

    components: {
        VFormBase,
    },

    props: {
        model: [Object, Array],
        schema: [Object, Array],
        headers: [Object, Array],
    },

    data: () => ({
        resizeObserver: null,

        contentCardHeight: '',

        filters: {},
        queryParams: {},

        currentRappel: null,

        contracts: [],
        selectedContractIndex: null,

        selectedPartition: [
            // Index 0 -> The default, only used in the first request / if the user doesn't have rappel data
            // Index 1  -> monthly
            // Index 3  -> trimester
            // Index 6  -> semester
            // Index 12 -> yearly
        ],

        rappelTotals: [],
        levels: [],

        trimesterMonths: [1, 4, 7, 10],
        semesterMonths: [1, 7],

        rappelType: 'Rappel Calculado',
        calculatedRappel: 'Rappel Calculado',
        paidRappel: 'Rappel Pago',

        contractCondition200NCC: '',
        contractCondition250NCC: '',
        contractCondition202CCE:'',
        contractCondition203CCP:'',
        contractCondition204CCNCE:'',
    }),

    watch: {
        'branchStore.branch': {
            handler: function (client) {
                if (!client) return;

                this.queryParams.branch_id = client.id;
                this.queryParams.client_number = client.client_number;

                // Reset previous selections, triggering a refresh.
                const initialState = this.$options.data.apply(this);
                this.selectedContractIndex = initialState.selectedContractIndex;
                this.rappelType = initialState.rappelType;
                this.selectedPartition = initialState.selectedPartition;
            },
            immediate: true,
        },

        selectedPartition: {
            handler: function () {
                this.refresh();
            },
            deep: true,
        },

        selectedContract: {
            handler: function () {
                this.queryParams.contract_id = this.selectedContract?.id;
            },
        }
    },

    computed: {
        ...mapStores(useBranchStore, useCategoriesStore,useAppStore),

        hasActiveFilters() {
            return Object.values(this.filters)
                .filter((x) => x) // ignore null or undefined
                .some((x) => (typeof x === 'string' && x !== '') || (Array.isArray(x) && x.length > 0) || (typeof x === 'object' && Object.keys(x).length > 0));
        },

        selectedContract() {
            return this.contracts.length !== 0 //
                ? this.contracts.at(this.selectedContractIndex)
                : null;
        },

        partitions() {
            return this.selectedContract?.period ?? 0;
        },

        visibleYears() {
            if (!this.filters.start_date || !this.filters.end_date) {
                return [];
            }

            const diff = moment(this.filters.end_date).year() - moment(this.filters.start_date).year() + 1;
            return [...Array(diff).keys()].map((i) => i + moment(this.filters.start_date).year());
        },

        selectedYear() {
            return this.selectedPartition.at(this.partitions) !== undefined //
                ? moment(this.selectedPartition.at(this.partitions)).year()
                : this.visibleYears[0];
        },

        selectedMonth() {
            return this.selectedPartition.at(this.partitions) !== undefined //
                ? moment(this.selectedPartition[this.partitions]).month() + 1
                : null;
        },

        rappelTotalsPerYear() {
            const rappelForYear = {};

            for (const rappel of this.rappelTotals) {
                const getTimestamp = (date) => (date ? new Date(date).getTime() : null);

                const documentDate = getTimestamp(rappel.document_date);
                const startDate = getTimestamp(this.selectedContract?.start_date);
                const endDate = getTimestamp(this.selectedContract?.end_date);

                // The rappel is for that contract if: documentDate \in [startDate, endDate]
                const validStartingDate = startDate && startDate <= documentDate;
                const validEndingDate = endDate && endDate >= documentDate;

                if (validStartingDate && validEndingDate) {
                    rappelForYear[rappel.document_year] ??= [];
                    rappelForYear[rappel.document_year].push(rappel);
                }
            }

            return rappelForYear;
        },

        selectedRappel() {
            const rappelForYear = this.rappelTotalsPerYear[this.selectedYear] ?? [];

            if (!this.selectedYear || !this.selectedMonth) {
                return rappelForYear;
            }

            const range = this.getMonthRange(this.selectedYear, this.selectedMonth);
            return rappelForYear.filter((it) => range.includes(it.document_year_month));
        },
        isMobile(){
            return this.appStore.mobile_ls?false:this.appStore.is_mobile;
        },

        headerProps(){
            return this.appStore.header_props
        }
    },

    created() {
        this.applyDefaultFilters();
    },

    mounted() {
        this.prepareResponsiveBehavior();
        this.refresh()
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.computeDatatableSize);
        this.resizeObserver?.unobserve(this.$refs.headerFilters);
    },

    methods: {
        onPaidRappelClick() {
            if (!this.selectedMonth) {
                this.showError(this.tb('Para ativar, selecione o mês a consultar.'));
            }
        },

        hasRappelTotalsAt(year, position) {
            const rappelTypesForYear = this.rappelTotalsPerYear[year] ?? [];
            const range = this.getMonthRange(year, position);

            return rappelTypesForYear.filter((it) => range.includes(it.document_year_month)).length > 0;
        },

        getRappelTotalsAt(type, year, position) {
            const rappelTypesForYear = this.rappelTotalsPerYear[year] ?? [];
            const range = this.getMonthRange(year, position);

            return rappelTypesForYear.filter((it) => it.document_type === type && range.includes(it.document_year_month)).at(0);
        },

        rappelTypes(year) {
            const totals = this.rappelTotalsPerYear[year] ?? [];

            if (totals.length === 0) return ['NORMAL'];
            if (totals.every((it) => it.document_type === 'NORMAL')) return ['NORMAL'];
            if (totals.every((it) => it.document_type === 'EXCLUSIVOS')) return ['EXCLUSIVOS'];
            return ['NORMAL', 'EXCLUSIVOS'];
        },

        getRappelTypeLabel(type, year) {
            const rappelForYearAndType = this.rappelTotalsPerYear[year]?.filter((it) => it.document_type === type) ?? [];

            if (type === 'NORMAL' && rappelForYearAndType.length === 0) {
                return '';
            }

            return type === 'NORMAL' ? ` ${this.$t('rappel.inProduct')}` : ` ${this.$t('rappel.inExclusive')}`;
        },

        removeFilter(filters, index) {
            filters.splice(index, 1);
            this.refresh();
        },

        refresh() {
            if (!this.branchStore.branch) return;

            if (!this.filters.start_date) {
                this.schema.end_date.minDate = null;

                this.showError(this.tb('Escolha uma data de início para serem apresentados os períodos de rappel.'));
                return;
            }
            if (!this.filters.end_date) {
                this.showError(this.tb('Escolha uma data de fim para serem apresentados os períodos de rappel.'));
                return;
            }

            this.schema.end_date.minDate = this.filters.start_date;

            const minEndDate = moment(this.filters.start_date).format('YYYY-MM');
            if (moment(this.filters.end_date) < moment(minEndDate)) this.filters.end_date = minEndDate;

            this.queryParams.years = this.visibleYears;
            this.queryParams.year = this.selectedYear;
            this.queryParams.month = this.selectedPartition.at(this.partitions)
                ? moment(this.selectedPartition.at(this.partitions)).month() + 1 // @Note: moment month starts at 0
                : 0;
            this.queryParams.contract_id = this.selectedContract?.id;
            this.queryParams.start_date = this.filters?.start_date;
            this.queryParams.end_date = this.filters?.end_date;
            this.getRappelTotals();
        },

        getRappelTotals() {
            axios
                .get('/api/financial/rappel/totals', {
                    params: this.queryParams,
                })
                .then((response) => {
                    this.contracts = response.data.contracts ?? [];
                    this.selectedContractIndex ??= this.contracts.length - 1; // @Note: The most recent contract is the one on the right.
                    this.currentRappel = response.data.currentRappel;
                    this.rappelTotals = response.data.rappelTotals ?? [];
                    this.levels = response.data.levels ?? [];
                    this.contractCondition200NCC = response.data.contractCondition200NCC;
                    this.contractCondition250NCC = response.data.contractCondition250NCC;
                    this.contractCondition202CCE = response.data.contractCondition202CCE;
                    this.contractCondition203CCP = response.data.contractCondition203CCP;
                    this.contractCondition204CCNCE = response.data.contractCondition204CCNCE;

                })
                .catch((error) => {
                    console.log(error.response);

                    this.contracts = [];
                    this.selectedContractIndex = null;
                    this.currentRappel = null;
                    this.rappelTotals = [];
                    this.levels = [];
                    this.contractCondition200NCC = null;
                    this.contractCondition250NCC = null;
                    this.contractCondition202CCE = null;
                    this.contractCondition203CCP = null;
                    this.contractCondition204CCNCE = null;

                    this.showError(this.tb('Não foi possível carregar os valores de Rappel para o cliente selecionado.'));
                });
        },

        getMonthRange(year, position) {
            if (this.rappelTotals.length === 0) {
                return [];
            }

            const generateRange = (start, end) => {
                return [...Array(end - start + 1)].map((_, i) => this.momentDate(year, i + start));
            };

            if (this.partitions === 1) {
                return [this.momentDate(year, position)];
            }
            if (this.partitions === 3) {
                switch (position) {
                case 1:
                case 2:
                case 3:
                    return generateRange(1, 3);
                case 4:
                case 5:
                case 6:
                    return generateRange(4, 6);
                case 7:
                case 8:
                case 9:
                    return generateRange(7, 9);
                case 10:
                case 11:
                case 12:
                    return generateRange(10, 12);
                default:
                    return generateRange(1, 12);
                }
            }
            if (this.partitions === 6) {
                switch (position) {
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                    return generateRange(1, 6);
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                    return generateRange(7, 12);
                default:
                    return generateRange(1, 12);
                }
            }
            if (this.partitions === 12) {
                return generateRange(1, 12);
            }
        },

        applyDefaultFilters() {
            for (let field in this.model) {
                this.$set(this.filters, field, this.model[field]);
            }
        },

        onClearFilters() {
            this.applyDefaultFilters();
            this.refresh();
        },

        prepareResponsiveBehavior() {
            const makeResponsive = () => {
                this.computeDatatableSize();
            };

            this.resizeObserver = new ResizeObserver(makeResponsive);
            this.resizeObserver.observe(this.$refs.headerFilters);

            window.addEventListener('resize', makeResponsive);

            makeResponsive();
        },

        computeDatatableSize() {
            const topElement = this.$refs.headerFilters;

            if (topElement) {
                const topHeight = topElement.getBoundingClientRect().bottom;
                const res = window.innerHeight - 75 - topHeight;
                this.contentCardHeight = res;
            }
        },

        downloadInvoice(partitions, year, position) {
            this.isLoading = true;

            axios({
                url: '/api/financial/rappel/paid_rappel',
                responseType: 'blob',
                params: {
                    client_number: this.branchStore.branch.client_number,
                    selectedYear: year,
                    partitions: partitions,
                    position: position,
                },
            })
                .then((response) => {
                    let fileURL = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
                    let fileLink = document.createElement('a');

                    fileLink.href = fileURL;
                    fileLink.download = this.getFileName(partitions, year, position);

                    fileLink.click();
                })
                .catch(() => {
                    this.showError(this.tb('Não foi possível descarregar o documento.'));
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        getFileName(partitions, year, position) {
            let date = '';

            switch (partitions) {
            case 1:
                date = year + '-' + position + '-01';
                break;

            case 3:
            case 6:
                date = year + '-' + partitions * position + '-01';
                break;

            case 12:
                date = year + '-' + partitions + '-01';
                break;
            }

            let calculatedDate = moment(date).endOf('month').format('YYYYMMDD');
            return 'rappel_' + this.branchStore.branch.client_number + '_' + calculatedDate;
        },

        momentDate(year, month) {
            if(month<10){
                return year + '-0' + month
            }else{
                return year + '-' + month
            }
            //return moment(year + '-' + month).format('YYYY-MM');
        },

        showMonth(year, month) {
            const d = this.momentDate(year, month);
            const startDate = moment(this.filters.start_date).format('YYYY-MM');
            const endDate = moment(this.filters.end_date).format('YYYY-MM');

            return startDate <= d && endDate >= d;
        },
    },
};
</script>

<style scoped>
.month-container {
    width: 75px;
    margin: 4px !important;
}

.trimester-container {
    width: 155px;
    margin: 4px !important;
}

.semester-container {
    width: 260px;
    margin: 4px !important;
}

.year-container {
    width: 116px;
    margin: 4px !important;
}

.monthly-input {
    width: 83px;
}

.trimester-input {
    width: 163px;
}

.semester-input {
    width: 268px;
}

.yearly-input {
    width: 122px;
}
</style>

<style>
.max-pagination-height > .v-pagination {
    height: 24px !important;
}
.max-pagination-height > .v-pagination .v-pagination__item {
    font-size: 12px !important;
}

.v-text-field {
    margin-top: 0 !important;
}

.v-text-field input {
    padding: 4px 0 !important;
    margin-top: 0 !important;
}

#form-base > div > .v-input > .v-input__control > .v-input__slot .v-input__icon--prepend-inner button.v-icon {
    color: #154579;
    font-size: 18px !important;
}
</style>
